import dayjs from "./dayjs";

export const getDoctorExperience = (year: number) => {
  return dayjs().diff(`${year}-01-01`, "year");
};
